import { helper } from "@ember/component/helper";
import { htmlSafe } from "@ember/template";
import BioExamObservation from "core/models/loinc";
export function compute([bioExamObservation]) {
  const unit = bioExamObservation.unit;
  return unit ? htmlSafe(unit) : undefined;
}
export default helper(compute);